var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "myBaseInfo" } }, [
    _c(
      "div",
      {
        staticClass: "baseinfo-left",
        on: {
          click: function ($event) {
            return _vm.changeSpan($event)
          },
        },
      },
      [
        _c(
          "span",
          {
            staticClass: "baseinfo-span active-span",
            attrs: { "data-type": "baseinfo" },
          },
          [_vm._v("账号信息")]
        ),
        !_vm.hkFlag
          ? _c(
              "span",
              {
                staticClass: "baseinfo-span",
                attrs: { "data-type": "cancleinfo" },
              },
              [_vm._v("账号注销")]
            )
          : _vm._e(),
      ]
    ),
    _c(
      "div",
      { staticClass: "baseinfo-right" },
      [
        _c("div", { staticClass: "baseinfo-box" }, [
          _c("div", { staticClass: "photo" }, [
            _c("img", {
              staticClass: "head-icon",
              attrs: { src: _vm.photoUrl, width: "125", height: "125" },
            }),
            _c(
              "div",
              { staticClass: "btn" },
              [
                !_vm.hkFlag
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "info", plain: "" },
                        on: {
                          click: function ($event) {
                            _vm.changeAvatarDialogVisible = true
                          },
                        },
                      },
                      [_vm._v("更换头像")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "right-content" }, [
            _c("div", { staticClass: "basic-info" }, [
              _c("div", { staticClass: "basic-cont-left y-fc-999" }, [
                _c("span", { staticClass: "y-t-ac" }, [_vm._v("用户名称")]),
                _vm.userMess.nickName &&
                _vm.userMess.nickName !== _vm.userMess.mobile
                  ? _c("span", { staticClass: "y-fc-333 y-t-al y-f-ell" }, [
                      _vm._v(_vm._s(_vm.userMess.nickName)),
                    ])
                  : _c("span", { staticClass: "y-fc-333 y-t-al y-f-ell" }, [
                      _vm._v(
                        _vm._s(
                          _vm.userMess.encryptMobile ||
                            _vm.userMess.userName ||
                            _vm.userMess.mobile
                        )
                      ),
                    ]),
                _c("i", {
                  staticClass: "el-icon-edit y-t-al y-c-p",
                  on: {
                    click: function ($event) {
                      _vm.showUpdateNickNameDialog = true
                    },
                  },
                }),
              ]),
              !_vm.hkFlag
                ? _c("div", { staticClass: "basic-cont-left y-fc-999" }, [
                    _c("span", { staticClass: "y-t-ac" }, [_vm._v("账号密码")]),
                    _c("span", { staticClass: "y-fc-333 y-t-al" }, [
                      _vm._v("********"),
                    ]),
                    _c("i", {
                      staticClass: "el-icon-edit y-t-al y-c-p",
                      on: {
                        click: function ($event) {
                          _vm.changePasswordDialogVisible = true
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              !_vm.hkFlag
                ? _c("div", { staticClass: "basic-cont-left y-fc-999" }, [
                    _c("span", { staticClass: "y-t-ac" }, [_vm._v("绑定手机")]),
                    _c("span", { staticClass: "y-fc-333 y-t-al" }, [
                      _vm._v(_vm._s(_vm.encryptMobile)),
                    ]),
                    this.bindUserMobile
                      ? _c(
                          "span",
                          {
                            staticClass: "y-fc-4C84FF y-c-p y-t-ar",
                            on: {
                              click: function ($event) {
                                _vm.changeMobileDialogVisible = true
                              },
                            },
                          },
                          [_vm._v("绑定")]
                        )
                      : _c("i", {
                          staticClass: "el-icon-edit y-t-al y-c-p",
                          on: {
                            click: function ($event) {
                              _vm.changeMobileDialogVisible = true
                            },
                          },
                        }),
                  ])
                : _vm._e(),
              !_vm.hkFlag
                ? _c("div", { staticClass: "basic-cont-left y-fc-999" }, [
                    _c("span", { staticClass: "y-t-ac" }, [_vm._v("实名信息")]),
                    !_vm.isRealName
                      ? _c(
                          "span",
                          {
                            staticClass: "y-fc-333 y-t-al y-fc-4C84FF y-c-p",
                            on: {
                              click: function ($event) {
                                return _vm.openAuthRealNameDialog("add")
                              },
                            },
                          },
                          [_vm._v("您未实名认证，请先认证")]
                        )
                      : _c("span", { staticClass: "y-fc-333 y-t-al" }, [
                          _vm._v(_vm._s(_vm.certInfo.cerName)),
                        ]),
                    _c("i", {
                      staticClass: "el-icon-edit y-t-al y-c-p",
                      class: { "y-o-0": !_vm.isRealName },
                      on: {
                        click: function ($event) {
                          return _vm.openAuthRealNameDialog("edit")
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              !_vm.hkFlag
                ? _c("div", { staticClass: "basic-cont-left y-fc-999" }, [
                    _c("span", { staticClass: "y-t-ac" }, [
                      _vm._v("银行卡信息"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "y-fc-333 y-t-al y-fc-4C84FF y-c-p",
                        on: { click: _vm.toBankCard },
                      },
                      [_vm._v("我的银行卡")]
                    ),
                    _c("i", { staticClass: "el-icon-edit y-t-al y-c-p y-o-0" }),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("change-avatar", {
          attrs: { value: _vm.changeAvatarDialogVisible },
          on: { close: _vm.changeAvatar, update: _vm.getSrc },
        }),
        _c("change-mobile", {
          attrs: {
            value: _vm.changeMobileDialogVisible,
            bindUserMobileInfo: this.bindUserMobileInfo,
          },
          on: {
            close: function ($event) {
              _vm.changeMobileDialogVisible = false
            },
          },
        }),
        _c("change-password", {
          attrs: { value: _vm.changePasswordDialogVisible },
          on: {
            close: function ($event) {
              _vm.changePasswordDialogVisible = false
            },
          },
        }),
        _c("updateUserName", {
          attrs: { showUpdateNickNameDialog: _vm.showUpdateNickNameDialog },
          on: {
            "update:showUpdateNickNameDialog": function ($event) {
              _vm.showUpdateNickNameDialog = $event
            },
            "update:show-update-nick-name-dialog": function ($event) {
              _vm.showUpdateNickNameDialog = $event
            },
          },
        }),
        _c("AuthRealName", {
          attrs: {
            showAuthRealNameDialog: _vm.showAuthRealNameDialog,
            showType: _vm.showType,
            certInfo: _vm.certInfo,
          },
          on: {
            "update:showAuthRealNameDialog": function ($event) {
              _vm.showAuthRealNameDialog = $event
            },
            "update:show-auth-real-name-dialog": function ($event) {
              _vm.showAuthRealNameDialog = $event
            },
            update: _vm.getIsRealName,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }